import { ValueOfKey } from '../../../../utils-types';

export const PAYMENT_ISSUE_TABLE_MODE = {
  ALL: 'ALL',
  NUTRITION: 'NUTRITION',
  SCAN_IQ: 'SCAN_IQ',
} as const;

export type PaymentIssueTableMode = ValueOfKey<typeof PAYMENT_ISSUE_TABLE_MODE>;

export const PAYMENT_ISSUE_COLUMN = {
  NAME: 'NAME',
  SOLUTION: 'SOLUTION',
  COACH: 'COACH',
  SUBSCRIPTION: 'SUBSCRIPTION',
  PRICE: 'PRICE',
  ACTIVE_SINCE: 'ACTIVE_SINCE',
  DATE_OF_UPDATE: 'DATE_OF_UPDATE',
} as const;

export type PaymentIssueColumn = ValueOfKey<typeof PAYMENT_ISSUE_COLUMN>;
export type ShowColumnsConfig = Record<PaymentIssueColumn, boolean>;

export const COLUMN_WIDTHS: Record<PaymentIssueColumn, string> = {
  NAME: '1.25fr',
  SOLUTION: '1fr',
  COACH: '1fr',
  SUBSCRIPTION: '1.15fr',
  PRICE: '0.6fr',
  ACTIVE_SINCE: '0.85fr',
  DATE_OF_UPDATE: 'auto',
};
